export default __webpack_public_path__ + "static/media/cobra.58cc1e50.png";